module.exports = __webpack_public_path__ + "img/en.29ec6187.svg";